import { Pipe, PipeTransform } from '@angular/core';
import { AssetVersionDto, AssetVideoTypeDataDto } from '@picflow/types';

@Pipe({
  name: 'videoTimePercentToFrameCount',
  standalone: true,
})
export class VideoTimePercentToFrameCountPipe implements PipeTransform {
  transform(fraction: number | [number, number], assetVersion: AssetVersionDto): number {
    if (!assetVersion) return;

    if (Array.isArray(fraction)) {
      fraction = fraction[0];
    }

    const frame = Number((assetVersion.data as AssetVideoTypeDataDto).frame_count) * fraction;
    return Math.round(frame);
  }
}
